module.exports = __webpack_public_path__ + "static/media/GPG601A_F01_CE.1181fcd8.jpg";